module.exports = "<app-header></app-header>\r\n<div class=\"app-body\">\r\n  <app-sidebar></app-sidebar>\r\n  <!-- Main content -->\r\n  <main class=\"main\">\r\n    <div class=\"container-fluid\">\r\n      <router-outlet></router-outlet>\r\n    </div><!-- /.conainer-fluid -->\r\n  </main>\r\n</div>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/containers/full-layout/full-layout.component.html
// module id = ../../../../../src/app/containers/full-layout/full-layout.component.html
// module chunks = main